function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFertility = function SvgFertility(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 13v-1a2 2 0 0 1 2-2h2M6 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 20v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1m-6-8a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 10h2a2 2 0 0 1 2 2v1m-6-8a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
  }));
};
export default SvgFertility;